"use client";

import { Star, Quote } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  author: "Jane D.",
  position: "Happy Pet Owner",
  quote: "EquiCanine provided exceptional care for my dog and horse. Highly recommend!",
  rating: 5
}, {
  id: 2,
  author: "Mark S.",
  position: "Satisfied Client",
  quote: "My horses and dogs are in the best hands here. Friendly staff and excellent facilities.",
  rating: 5
}];
export default function Testimonials() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="testimonials" className="dark bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto space-y-16">
        <div className="text-center space-y-4">
          <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight text-foreground-dark">
            What Our Clients Say
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Trusted care for your beloved horses and dogs
          </p>
        </div>

        <div className="space-y-12">
          <div ref={ref1} data-index={0} className={`transition-all duration-[150ms] ease-out ${isVisible1 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
            <Card className="relative bg-dark-background border border-white/10 shadow-soft hover-lift overflow-visible">
              <Quote className="absolute -top-4 -left-4 size-12 text-primary/40 transition-all duration-[150ms] ease-out group-hover:text-primary/60" strokeWidth={1.5} />
              <CardContent className="pt-8 pb-6 space-y-6">
                <p className="text-foreground-dark text-lg leading-relaxed italic">
                  "{testimonials[0].quote}"
                </p>
                <div className="flex items-center justify-between">
                  <div className="space-y-1">
                    <p className="font-semibold text-foreground-dark text-base">
                      {testimonials[0].author}
                    </p>
                    <p className="text-sm text-muted-foreground">
                      {testimonials[0].position}
                    </p>
                  </div>
                  <div className="flex gap-1 opacity-80 hover:opacity-100 transition-opacity duration-[80ms]">
                    {Array.from({
                    length: testimonials[0].rating
                  }).map((_, i) => <Star key={i} data-index={i} className="size-5 fill-secondary text-secondary" />)}
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          <div ref={ref2} data-index={1} className={`transition-all duration-[150ms] ease-out ${isVisible2 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
            <Card className="relative bg-dark-background border border-white/10 shadow-soft hover-lift overflow-visible">
              <Quote className="absolute -top-4 -left-4 size-12 text-primary/40 transition-all duration-[150ms] ease-out group-hover:text-primary/60" strokeWidth={1.5} />
              <CardContent className="pt-8 pb-6 space-y-6">
                <p className="text-foreground-dark text-lg leading-relaxed italic">
                  "{testimonials[1].quote}"
                </p>
                <div className="flex items-center justify-between">
                  <div className="space-y-1">
                    <p className="font-semibold text-foreground-dark text-base">
                      {testimonials[1].author}
                    </p>
                    <p className="text-sm text-muted-foreground">
                      {testimonials[1].position}
                    </p>
                  </div>
                  <div className="flex gap-1 opacity-80 hover:opacity-100 transition-opacity duration-[80ms]">
                    {Array.from({
                    length: testimonials[1].rating
                  }).map((_, i) => <Star key={i} data-index={i} className="size-5 fill-secondary text-secondary" />)}
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}